import { render, staticRenderFns } from "./AddressCountryInputWithoutFetch.vue?vue&type=template&id=11cdc3a0&scoped=true&"
import script from "./AddressCountryInputWithoutFetch.vue?vue&type=script&lang=js&"
export * from "./AddressCountryInputWithoutFetch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cdc3a0",
  null
  
)

/* custom blocks */
import block0 from "./AddressCountryInputWithoutFetch.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./AddressCountryInputWithoutFetch.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
